<ng-template #noFileTemplate>
    <div
        class="fill action-available"
        (click)="onClick($event)"
        aumico-drop-file
        (fileDroppedEvent)="onFileDropped($event)"
        (stateEvent)="onStateEvent($event)"
        [accept]="accept"
    >
        <div
            class="root-no-file root-padding fill flex-column center-flex inner-container"
            [ngClass]="{ 'file-inside': fileInside }"
        >
            <span class="instruction-text">{{ instructionTextKey | i18next }}</span>

            <span style="padding: calc(22px / 2)"></span>

            <span class="aumico-pattern-icon-upload" [ngClass]="{ 'file-inside': fileInside }"><i></i></span>

            <span style="padding: calc(8px / 2)"></span>

            <span class="instruction-label">{{ instructionLabelKey | i18next }}</span>

            <span class="extension-error" *ngIf="fileExtensionError">{{ extensionErrorKey | i18next }} </span>
        </div>
    </div>
</ng-template>

<ng-template #withFileTemplate>
    <div>
        <div class="fill flex-row root-padding-with-file start-flex inner-container tint-on-hover">
            <span
                [ngClass]="{
                    'tint-purple-svg': tint,
                    'aumico-pattern-icon-xls': accept == '.xls,.xlsx,.XLSX,.XLS',
                    'aumico-pattern-icon-pdf': accept == '.pdf'
                }"
                ><i></i
            ></span>

            <span style="padding: calc(11px / 2)"></span>

            <span class="filename" [ngClass]="{ 'tint-purple-text': tint }">{{ currentFileName }}</span>

            <span style="padding: calc(12.5px / 2)"></span>

            <span
                (click)="onBinClicked($event)"
                class="aumico-pattern-icon-bin action-available"
                [ngClass]="{ 'tint-purple-svg': tint }"
                ><i></i
            ></span>
        </div>
    </div>
</ng-template>

<ng-container>
    <span>{{ title }}</span>
    <ng-container *ngIf="currentFileName; then withFileTemplate; else noFileTemplate"> </ng-container>
    <input #fileInput class="d-none" hidden type="file" (change)="onFileChange($event)" [accept]="accept" />
</ng-container>
